/* import __COLOCATED_TEMPLATE__ from './top-navigation-header.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();